import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../images/logo.png";
import "aos/dist/aos.css";
import "../index.css";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed top-0 left-0 w-full bg-black bg-opacity-80 z-50 font-bonaNova">
      <div className="flex items-center justify-between px-4 py-2 md:px-8">
        {/* Logo */}
        <img
          src={logo}
          alt="logo"
          className="w-10 h-10 md:w-12 md:h-12" // Adjusted logo size
        />
        {/* Desktop Navigation */}
        <nav className="hidden md:flex ml-auto space-x-6">
          {[
            "about",
            "skills",
            "certifications",
            "projects",
            "explorations",
            "testimonials",
            "profiles",
          ].map((section) => (
            <ScrollLink
              key={section}
              to={section}
              smooth={true}
              duration={500}
              offset={-70}
              className="text-white cursor-pointer hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 hover:text-transparent hover:bg-clip-text transform hover:scale-105 transition duration-300 ease-in-out px-3 py-1 rounded-md"
            >
              {section.charAt(0).toUpperCase() +
                section
                  .slice(1)
                  .replace(/([A-Z])/g, " $1")
                  .trim()}
            </ScrollLink>
          ))}
        </nav>
        {/* Hamburger Menu */}
        <div className="md:hidden flex items-center">
          <FaBars
            className="text-white cursor-pointer text-xl"
            onClick={toggleSidebar}
          />
        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center space-y-6 z-50 px-4 py-6">
          <FaTimes
            className="text-white cursor-pointer text-3xl absolute top-4 right-4"
            onClick={toggleSidebar}
          />
          {[
            "about",
            "skills",
            "certifications",
            "projects",
            "explorations",
            "testimonials",
            "profiles",
          ].map((section) => (
            <ScrollLink
              key={section}
              to={section}
              smooth={true}
              duration={500}
              offset={-70}
              className="text-white text-lg cursor-pointer hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 hover:text-transparent hover:bg-clip-text transform hover:scale-105 transition duration-300 ease-in-out px-4 py-2 rounded-md"
              onClick={toggleSidebar}
            >
              {section.charAt(0).toUpperCase() +
                section
                  .slice(1)
                  .replace(/([A-Z])/g, " $1")
                  .trim()}
            </ScrollLink>
          ))}
        </div>
      )}
    </div>
  );
}
